import Alarm from 'components/Common/Alarm/Alarm';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import PlantHomePage from './pages/PlantHomePage/PlantHomePage';
import PlantMaintenance from './pages/PlantMaintenance/PlantMaintenance';
import PlantManagement from './pages/PlantManagement/PlantManagement';
import PlantReport from './pages/PlantReport/PlantReport';
// import ManagementUser from './pages/Management/Management';

export default function PlantFeature() {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/home/:id`} exact>
        <PlantHomePage />
      </Route>
      <Route path={`${match.path}/management/:id`} exact>
        <PlantManagement />
      </Route>
      <Route path={`${match.path}/maintenance/:id`} exact>
        <PlantMaintenance />
      </Route>
      <Route path={`${match.path}/alarm/:id`} exact>
        <Alarm />
      </Route>
      <Route path={`${match.path}/report/:id`} exact>
        <PlantReport />
      </Route>
    </Switch>
  );
}
